import script from "./ChangeIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeIndicator.vue?vue&type=script&setup=true&lang=js"

import "./ChangeIndicator.vue?vue&type=style&index=0&id=f71449d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f71449d4"]])

export default __exports__